/*
Used static data for faster rendering. 
**/

export const default_currencies = [
  { defaultCurrency: 'AUD', description: 'Australian Dollar', avatar: require('@/assets/icons/currencies/au.png') },
  { defaultCurrency: 'CAD', description: 'Canadian Dollar', avatar: require('@/assets/icons/currencies/ca.png') },
  { defaultCurrency: 'EUR', description: 'Euro', avatar: require('@/assets/icons/currencies/eu.png') },
  { defaultCurrency: 'GBP', description: 'British Pound', avatar: require('@/assets/icons/currencies/gb.png') },
  { defaultCurrency: 'USD', description: 'US Dollar', avatar: require('@/assets/icons/currencies/us.png') },
]
//don't mix php with default_currencies since it is used as option list for base currencies
export const ph_currency = {
    defaultCurrency: 'PHP', description: 'Philippine Peso', avatar: require('@/assets/icons/currencies/ph.png')
}

export function getCurrencyAvatar(currency) {
    if (!currency || currency == 'PHP') return ph_currency.avatar
    const data = default_currencies.find(x => x.defaultCurrency === currency)
    return data ? data.avatar : ''
}
